export const getDropdownList = () => {
  let list = [];
  regionalConfig.forEach( region => {
    region.countries.forEach( country => {
      list.push({
        id: country.countryCode,
        title: country.countryName,
        androidURL: region.redirectAndroidUrl,
        iosURL: region.redirectIOSUrl.replace("COUNTRY", country.countryCode),
        region: region.region
      });
    });
  });

  return list;
}

export const getCountries = () => {
  let list = [];
  regionalConfig.forEach(region => {
    region.countries.forEach(country => {
      list.push({
        id: country.countryCode,
        title: country.countryName,
      });
    });
  });

  return list;
}

const regionalConfig = [
  {
    region: "Europe",
    countries: [
      { countryName: "Azərbaycan", countryCode: "az" },
      { countryName: "Australia", countryCode: "au" },
      { countryName: "Беларусь", countryCode: "by" },
      { countryName: "Belgique", countryCode: "be" },
      { countryName: "Bosna i Hercegovina", countryCode: "ba" },
      { countryName: "България", countryCode: "bg" },
      { countryName: "Hrvatska", countryCode: "hr" },
      { countryName: "Κύπρος", countryCode: "cy" },
      { countryName: "Česká republika", countryCode: "cz" },
      { countryName: "Danmark", countryCode: "dk" },
      { countryName: "Eesti", countryCode: "ee" },
      { countryName: "Suomi", countryCode: "fi" },
      { countryName: "France", countryCode: "fr" },
      { countryName: "საქართველო", countryCode: "ge" },
      { countryName: "Deutschland", countryCode: "de" },
      { countryName: "Ελλάδα", countryCode: "gr" },
      { countryName: "Magyarországon", countryCode: "hu" },
      { countryName: "Eire", countryCode: "ie" },
      { countryName: "ישראל", countryCode: "il" },
      { countryName: "Italia", countryCode: "it" },
      { countryName: "Қазақстан", countryCode: "kz" },
      { countryName: "Latvija", countryCode: "lv" },
      { countryName: "Lietuva", countryCode: "lt" },
      { countryName: "Luxemburg", countryCode: "lu" },
      { countryName: "Malta", countryCode: "mt" },
      { countryName: "Moldova", countryCode: "md" },
      { countryName: "Maroc", countryCode: "ma" },
      { countryName: "Nederland", countryCode: "nl" },
      { countryName: "Norge", countryCode: "no" },
      { countryName: "Österreich", countryCode: "at" },
      { countryName: "Polska", countryCode: "pl" },
      { countryName: "Portugal", countryCode: "pt" },
      { countryName: "România", countryCode: "ro" },
      { countryName: "Россия", countryCode: "ru" },
      { countryName: "Србија", countryCode: "rs" },
      { countryName: "Slovensko", countryCode: "sk" },
      { countryName: "Slovenija", countryCode: "sl" },
      { countryName: "España", countryCode: "es" },
      { countryName: "Sverige", countryCode: "se" },
      { countryName: "Schweiz", countryCode: "ch" },
      { countryName: "Türkiye", countryCode: "tr" },
      { countryName: "United Kingdom", countryCode: "gb" },
      { countryName: "Україна", countryCode: "ua" }
    ],
    redirectIOSUrl: "https://itunes.apple.com/COUNTRY/app/new-happy-studio/id1030805441?mt=8",
    redirectAndroidUrl: "https://play.google.com/store/apps/details?id=com.mcdonalds.happystudio.eu",
    appName: "Happy Studio"
  },
  {
    region: "Asia Pacific",
    countries: [
      { countryName: "Hong Kong", countryCode: "hk" },
      { countryName: "Indonesia", countryCode: "id" },
      { countryName: "India", countryCode: "in" },
      { countryName: "Korea", countryCode: "kr" },
      { countryName: "Malaysia", countryCode: "my" },
      { countryName: "Phillipines", countryCode: "ph" },
      { countryName: "Singapore", countryCode: "sg" },
      { countryName: "Taiwan", countryCode: "tw" },
      { countryName: "Thailand", countryCode: "th" },
      { countryName: "Vietnam", countryCode: "vn" }
    ],
    redirectIOSUrl: "https://itunes.apple.com/COUNTRY/app/mcdonalds-happy-studio-asia/id1209978668?ls=1&mt=8",
    redirectAndroidUrl: "https://play.google.com/store/apps/details?id=com.mcdonalds.happystudio.apac",
    appName: "Happy Studio"
  },
  {
    region: "Middle East",
    countries: [
      { countryName: "Bahrain", countryCode: "bh" },
      { countryName: "Egypt", countryCode: "eg" },
      { countryName: "Jordan", countryCode: "jo" },
      { countryName: "Kuwait", countryCode: "kw" },
      { countryName: "Mauritius", countryCode: "mu" },
      { countryName: "Oman", countryCode: "om" },
      { countryName: "Pakistan", countryCode: "pk" },
      { countryName: "Qatar", countryCode: "qa" },
      { countryName: "Saudi Arabia", countryCode: "sa" },
      { countryName: "Shqipëri", countryCode: "lb" },
      { countryName: "South Africa", countryCode: "za" },
      { countryName: "Sri Lanka", countryCode: "lk" },
      { countryName: "United Arab Emirates", countryCode: "ae" }
    ],
    redirectIOSUrl: "https://itunes.apple.com/COUNTRY/app/mcdonalds-happy-studio-mea/id1209978654?ls=1&mt=8",
    redirectAndroidUrl: "https://play.google.com/store/apps/details?id=com.mcdonalds.happystudio.mea",
    appName: "Happy Studio"
  },
  {
    region: "Latin America",
    countries: [
      { countryName: "Argentina", countryCode: "ar" }
    ],
    redirectIOSUrl: "https://itunes.apple.com/COUNTRY/app/mcplay-argentina/id978185772?mt=8",
    redirectAndroidUrl: "https://play.google.com/store/apps/details?id=com.mcdo.argentina.mcplay",
    appName: "McPlay"
  },
  {
    region: "Latin America",
    countries: [
      { countryName: "Chile", countryCode: "cl" },
      { countryName: "Colombia", countryCode: "co" },
      { countryName: "Costa Rica", countryCode: "cr" },
      { countryName: "Ecuador", countryCode: "ec" },
      { countryName: "El Salvador", countryCode: "sv" },
      { countryName: "Guatamala", countryCode: "gt" },
      { countryName: "Honduras", countryCode: "hn" },
      { countryName: "Mexico", countryCode: "mx" },
      { countryName: "Nicaragua", countryCode: "ni" },
      { countryName: "Panama", countryCode: "pa" },
      { countryName: "Peru", countryCode: "pe" },
      { countryName: "Uraguay", countryCode: "uy" }
    ],
    redirectIOSUrl: "https://itunes.apple.com/COUNTRY/app/mcplay/id634672279?mt=8",
    redirectAndroidUrl: "https://play.google.com/store/apps/details?id=com.mcdo.latam.mcplay",
    appName: "McPlay"
  },
  {
    region: "North America",
    countries: [
      { countryName: "Canada", countryCode: "ca" },
      { countryName: "United States", countryCode: "us" }
    ],
    redirectIOSUrl: "https://itunes.apple.com/COUNTRY/app/mcplay/id634672279?mt=8",
    redirectAndroidUrl: "https://play.google.com/store/apps/details?id=com.happymeal.mcplay",
    appName: "McPlay"
  }
];